export default __webpack_public_path__ + "static/media/nodes_card.9edc099d.jpg";